/* ============================================================================
   CY MENU ACCORDION
   One section open at a time in the mobile drawer. Opening any row closes its
   siblings at the same level, so the menu never grows into a long scroll.

   Why JavaScript: snippets/menu_mobile.liquid is an original theme file this
   project never edits, and neither it nor the header sections expose an
   exclusive-accordion setting.

   How it closes things matters. <hdt-accordion> is a custom element with a
   public toggle(open) method that dispatches the theme's own "pick" event and
   plays its height animation; yanking the details[open] attribute directly
   would skip that and leave the row snapping shut with a stale aria-expanded.
   So this asks the element to close itself and stays out of the way.

   The listener is on capture because the native `toggle` event does NOT bubble
   - a plain listener on the drawer would never fire.
   ========================================================================== */
(function () {
  'use strict';

  var DRAWER = '.hdt-header-menu-mobile';
  var busy = false;          /* re-entry guard: closing siblings fires more toggles */

  /* the accordion that owns this <li>, ignoring any nested deeper down */
  function accordionOf(li) {
    var a = li.querySelector('hdt-accordion');
    return (a && a.closest('li') === li) ? a : null;
  }

  function closeDescendants(root) {
    root.querySelectorAll('hdt-accordion').forEach(function (a) {
      /* Support's groups stay open for good (cy-mb-flat, owner 2026-10-01: closing them emptied Support) */
      if (a.closest('[data-cy-keep-open]')) return;
      if (a.open && typeof a.toggle === 'function') a.toggle(false);
    });
  }

  function onToggle(e) {
    var d = e.target;
    if (busy) return;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;   /* only react to opening */
    if (!d.closest || !d.closest(DRAWER)) return;           /* drawer only */

    var li = d.closest('li');
    if (!li || !li.parentElement) return;

    busy = true;
    try {
      Array.prototype.forEach.call(li.parentElement.children, function (sib) {
        if (sib === li || sib.tagName !== 'LI') return;
        var acc = accordionOf(sib);
        if (!acc || !acc.open || typeof acc.toggle !== 'function') return;
        /* collapse what is inside it first, so reopening starts clean */
        closeDescendants(sib);
        acc.toggle(false);
      });
    } finally {
      busy = false;
    }
  }

  function init() {
    /* one document-level capture listener covers rows the theme adds later */
    document.addEventListener('toggle', onToggle, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* SUPPORT GROUPS OPEN (owner list item 2, 2026-09-30): in the mobile menu, a top item that links to a PAGE (Support —
   the product families link to collections) shows its groups open: each group name becomes a small heading and its
   links sit under it, one tap away. Marks the item .cy-mb-flat; the CSS does the rest. */
(function () {
  'use strict';
  function flatten() {
    document.querySelectorAll('#menu_mobile .hdt-nav__ul-mb > li.hdt-has-children').forEach(function (li) {
      var top = li.querySelector(':scope > hdt-accordion > details > summary');
      if (!top || !/^\/pages\//.test(top.getAttribute('data-url') || '')) return;
      li.classList.add('cy-mb-flat');
      li.querySelectorAll('.hdt-mb-sub-menu-lever-1 > li > hdt-accordion > details').forEach(function (d) {
        d.open = true;
        d.closest('li').setAttribute('data-cy-keep-open', '');
        var sm = d.querySelector(':scope > summary');
        if (sm) { sm.setAttribute('tabindex', '-1'); sm.addEventListener('click', function (e) { e.preventDefault(); }); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', flatten); else flatten();
  document.addEventListener('shopify:section:load', flatten);
})();
